import { render, staticRenderFns } from "./IndustryModalForm.vue?vue&type=template&id=528ce523"
import script from "./IndustryModalForm.vue?vue&type=script&lang=js"
export * from "./IndustryModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports